import { SVGProps } from 'react';

const SvgTrashSlash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L491.3 359.8 508.4 128H520c13.3 0 24-10.7 24-24s-10.7-24-24-24h-69.8l-36.7-55.1C403.1 9.4 385.6 0 366.9 0h-93.8c-18.7 0-36.2 9.4-46.6 24.9L189.8 80H134.4L38.8 5.1zM195.6 128h264.7l-14.5 196.1L195.6 128zm77.5-80h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM155.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3h201.2c26.1 0 48.8-15.7 58.7-38.4l-42.1-33.1-.6 8.7c-.6 8.4-7.6 14.8-16 14.8H219.4c-8.4 0-15.3-6.5-16-14.8l-15.1-204.8-51.1-40.3 18.4 248.6z" />
  </svg>
);
export default SvgTrashSlash;
